<div
  class="item has-edit-button"
  *ngIf="componentType; else configureComponentBlock"
>
  <div *ngIf="!componentConfig">No component found for {{ componentType }}</div>
  <div *ngIf="isLoading">Loading...</div>
  <div *ngIf="errorMsg">Error loading data: {{ errorMsg }}</div>
  <div *ngIf="containerWideClass !== ''; else dynamicCmp" class="grid">
    <div
      class="container"
      [ngClass]="{
        'container--wide': containerWideClass === 'yes'
      }"
    >
      <div edsRow>
        <div edsCol>
          <ng-template #dynamicCmp></ng-template>
        </div>
      </div>
    </div>
  </div>
  <ng-template #dynamicCmp></ng-template>
</div>
<ng-template #configureComponentBlock
  >Click to configure Fund Performance Component</ng-template
>
